import { IcArticle16Icon } from '@gem/icons/messages';

import { CommonPayload } from '../CommonPayload/CommonPayload';

export const ArticlePayload = ({ name, payload }) => {
  return (
    <CommonPayload
      IcArticle16Icon={IcArticle16Icon}
      name={name}
      description={payload?.title}
    />
  );
};
